const state = {
  loading: false,
}

const getters = {
  loading: state => state.loading,
}

const mutations = {
  setLoading: (state, payload) => state.loading = payload,
}

const actions = {
  // module actions
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}